import React from "react";

function PrevButton({ onClick }) {
  return (
    <div
      onClick={onClick}
      className="h-[40px] w-[40px]  text-[25px] text-slate-100 rounded-full flex items-center justify-center active:bg-slate-300/10"
    >
      <i className="bi bi-skip-start-fill"></i>
    </div>
  );
}

export default PrevButton;
